import { __assign } from 'tslib';
import React from 'react';
import { PrimaryTabList } from './Component.js';
import { s as styles$1 } from '../../index.module-ee015487.js';
import '@juggle/resize-observer';
import 'classnames';
import '../../../../keyboard-focusable/esm';
import '../../../../shared/esm';
import '../../hooks/use-tabs.js';
import 'react-merge-refs';
import '../scrollable-container/Component.js';
import 'compute-scroll-into-view';
import '../scroll-controls/Component.js';
import 'lodash/debounce';
import '../../../../icon-button/esm';
import '@alfalab/icons-glyph/ChevronLeftCompactSIcon';
import '@alfalab/icons-glyph/ChevronRightCompactSIcon';
import '../scroll-controls/utils.js';
import '../title/Component.js';
import '../../../../skeleton/esm';

var mobileStyles = {"title":"tabs__title_jcdha tabs__title_1ndvl","mobile":"tabs__mobile_jcdha","paragraph-primary-large":"tabs__paragraph-primary-large_jcdha","paragraph-primary-medium":"tabs__paragraph-primary-medium_jcdha","paragraph-primary-small":"tabs__paragraph-primary-small_jcdha","action-primary-large":"tabs__action-primary-large_jcdha","action-primary-medium":"tabs__action-primary-medium_jcdha","action-primary-small":"tabs__action-primary-small_jcdha","accent-primary-large":"tabs__accent-primary-large_jcdha","accent-primary-medium":"tabs__accent-primary-medium_jcdha","accent-primary-small":"tabs__accent-primary-small_jcdha","pickerWrapper":"tabs__pickerWrapper_jcdha","option":"tabs__option_jcdha","scrollControls":"tabs__scrollControls_jcdha","headline-system-xlarge":"tabs__headline-system-xlarge_jcdha","headline-system-large":"tabs__headline-system-large_jcdha","headline-system-medium":"tabs__headline-system-medium_jcdha","headline-system-small":"tabs__headline-system-small_jcdha","headline-system-xsmall":"tabs__headline-system-xsmall_jcdha","headline-xlarge":"tabs__headline-xlarge_jcdha","headline-large":"tabs__headline-large_jcdha","headline-medium":"tabs__headline-medium_jcdha","headline-small":"tabs__headline-small_jcdha","headline-xsmall":"tabs__headline-xsmall_jcdha"};
require('./mobile.css');

var styles = __assign(__assign({}, styles$1), mobileStyles);
var PrimaryTabListMobile = function (props) { return (React.createElement(PrimaryTabList, __assign({}, props, { styles: styles, platform: 'mobile' }))); };

export { PrimaryTabListMobile };
